<template>
    <div class="total-employees-content card-box-style rounded rounded-30">
        <div class="main-title d-flex justify-content-between align-items-center">
            <h3>Total Employees</h3>
            <a href="#" class="view-btn">View All</a>
        </div>

        <div class="total-employees-chart text-center">
            <apexchart type="donut" height="315" :options="chartOptions" :series="series"></apexchart>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4">
                <div class="single-employees border-style-5c31d6">
                    <span class="title">Total</span>
                    <h4>634 <span>Employees</span></h4>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-4">
                <div class="single-employees border-style-fec107">
                    <span class="title">Men</span>
                    <h4>19,202 <span>+32.50%</span></h4>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-4">
                <div class="single-employees border-style-4fcb8d">
                    <span class="title">Women</span>
                    <h4>502 <span>+2%</span></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TotalEmployees',
    data: function() {
        return {
            series: [60, 40],
            chartOptions: {
                chart: { 
                    type: "donut", 
                    height: 300 
                }, 
                dataLabels: {
                    enabled: false
                },
                labels: [
                    "Taking Class", 
                    "Lesson Discuss", 
                    "Lesson Discuss"
                ], 
                colors: [
                    "#4FCB8D", 
                    "#1765FD", 
                ], 
                legend: { 
                    show: !1 
                }, 
                plotOptions: { 
                    pie: { 
                        donut: { 
                            size: "60%" 
                        } 
                    } 
                } 
            },
        };
    },
}
</script>

<style lang="scss">
.total-employees-content {
	padding: 30px 28px !important;
	padding-bottom: 14px !important;
	margin-bottom: 24px !important;
	.total-employees-chart {
		margin-bottom: 30px;
        .apexcharts-canvas {
            margin: auto;
        }
	}
	.main-title {
		margin-bottom: 38px;
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .total-employees-content {
        .total-employees-chart {
            margin-top: 0;
        }
        .col-sm-4 {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
    }
}
</style>